<template>
  <div class="table-box">
    <mf-loading :loader="['get-last-update', 'produtos-menos-clientes-top']" loader-type="table">
      <v-data-table :headers="headers" :items="produtosTopMenosClientes" hide-default-footer disable-pagination @current-items="updateSelectedItems">
        <template v-slot:item="{ item, index }">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>
              <router-link class="link" :to="{ path: `/produtos/detalhes-produto/${item['COD_ID_PRODUTO']}` }">
                {{ item['COD_ID_PRODUTO'] }} - {{ item['DES_PRODUTO'] }}
              </router-link>
            </td>
            <td class="text-right">{{ item['NUM_CUPONS_TOTAL'] | localeString }}</td>
            <td class="text-right">{{ item['VAL_FATURAMENTO_TOTAL'] | localeString(2) | currency }}</td>
            <td class="text-right">{{ item['NUM_CLIENTES_TOTAL'] | localeString }}</td>
            <td class="text-right">{{ item['VAL_QUANTIDADE_KG_TOTAL'] | localeString(1) }}</td>
          </tr>
        </template>
      </v-data-table>
    </mf-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { productRanking } from '@/modules/produtos/ranking-produtos/mixins/productRanking'

export default {
  mixins: [productRanking],
  computed: {
    ...mapGetters(['produtosTopMenosClientes']),
    hasPercentage() {
      return false
    },
  },
  methods: {
    ...mapWaitingActions({
      produtosMenosClientesTop: 'produtos-menos-clientes-top',
    }),
    internalGetData(filter) {
      return [this.produtosMenosClientesTop(filter)]
    },
  },
}
</script>
